import { createContext, useContext, useState, useCallback } from 'react';
import { MOCK_POSTS, nextPostId, nextCommentId } from '../assets/mockData';

const PostContext = createContext();

export function PostProvider({ children }) {
  const [posts, setPosts] = useState(MOCK_POSTS);

  const addPost = useCallback((post) => {
    setPosts((prev) => [{
      id: nextPostId(),
      ...post,
      likes: [],
      comments: [],
      createdAt: Date.now(),
    }, ...prev]);
  }, []);

  const toggleLike = useCallback((postId, userId) => {
    setPosts((prev) =>
      prev.map((p) => {
        if (p.id !== postId) return p;
        const liked = p.likes.includes(userId);
        return {
          ...p,
          likes: liked
            ? p.likes.filter((id) => id !== userId)
            : [...p.likes, userId],
        };
      })
    );
  }, []);

  const addComment = useCallback((postId, userId, content) => {
    setPosts((prev) =>
      prev.map((p) => {
        if (p.id !== postId) return p;
        return {
          ...p,
          comments: [
            ...p.comments,
            { id: nextCommentId(), userId, content, time: Date.now() },
          ],
        };
      })
    );
  }, []);

  const deletePost = useCallback((postId) => {
    setPosts((prev) => prev.filter((p) => p.id !== postId));
  }, []);

  return (
    <PostContext.Provider value={{ posts, addPost, toggleLike, addComment, deletePost }}>
      {children}
    </PostContext.Provider>
  );
}

export function usePosts() {
  return useContext(PostContext);
}
